/** The mark's arrow: one dark arrow with a barely curved edge, no fold line. */
export const MARK_PATH =
    "M2.5 11.5 Q11 6.2 21.5 2.5 Q19.3 12 15.5 21.5 Q13 17.6 11.2 13.3 Q6.6 12.9 2.5 11.5 Z";
